import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Link,
  Grid,
  IconButton
} from '@mui/material';


import LinkIcon from '@mui/icons-material/Link';
import ReactMarkdown from 'react-markdown';
import { markdownStyles } from './styles';

const BookMetadata = ({ book }) => {
    console.log("book data: ", book);
  const { id, data } = book.metadata;
  const { title, summary, author, book_id, metadata } = data;
  const gutenbergLink = `https://www.gutenberg.org/ebooks/${book_id}`;
  const coverImageUrl = `https://www.gutenberg.org/cache/epub/${book_id}/pg${book_id}.cover.medium.jpg`;

  return (
    <Card sx={{ marginBottom: 2, width: '100%' }}>
      <Grid container>
        <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Box sx={{ width: '50%', aspectRatio: '3/4', position: 'relative' }}>
            <CardMedia
              component="img"
              image={coverImageUrl}
              alt={title}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://www.gutenberg.org/cache/epub/${book.metadata.book_id}/pg${book.metadata.book_id}.cover.small.jpg`;
                e.target.width = 150;
                e.target.justifyContent = 'center';
              }}
              sx={{ height: '70%', width: '70%', objectFit: 'cover', position: 'relative', paddingTop: '20%' }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Typography variant="h6" component="div" sx={{ 
                fontFamily: '"Times New Roman"', flexGrow: 1, textAlign: 'left' }}>
                {title}
              </Typography>
            </Box>
            <Typography variant="body1" color="text.secondary" gutterBottom sx={{ 
              fontFamily: '"Verdana"', fontStyle: 'italic', textAlign: 'left' }}>
              {author}
            </Typography>
            <IconButton aria-label="link to project gutenberg" href={gutenbergLink} target="_blank" rel="noopener noreferrer">
              <LinkIcon />
            </IconButton>
            <Box sx={{ mt: 2, mb: 2, maxHeight: '200px', width: '98%', overflow: 'auto', 
                border: '1px solid #dfe1e5', boxShadow: '0 1px 6px rgba(32,33,36,.28)', padding: '5px'}}>
              <ReactMarkdown components={{
                p: ({ children }) => <Typography variant="body2" sx={markdownStyles}>{children}</Typography>,
                h1: ({ children }) => <Typography variant="h6" sx={markdownStyles}>{children}</Typography>,
                h2: ({ children }) => <Typography variant="subtitle1" sx={markdownStyles}>{children}</Typography>,
                h3: ({ children }) => <Typography variant="subtitle2" sx={markdownStyles}>{children}</Typography>,
                ul: ({ children }) => <ul style={{ ...markdownStyles, paddingLeft: '20px' }}>{children}</ul>,
                ol: ({ children }) => <ol style={{ ...markdownStyles, paddingLeft: '20px' }}>{children}</ol>,
              }}>
                {summary}
              </ReactMarkdown>
            </Box>
          </CardContent>
        </Grid>
      </Grid>
    </Card>
    // <Card sx={{ 
    //   width: '100%',
    //   boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    // }}>
    //   <Box sx={{ display: 'flex' }}>
    //     <CardMedia
    //       component="img"
    //       sx={{ width: 100, objectFit: 'cover' }}
    //       image={coverImageUrl}
    //       alt={title}
    //     />
    //     <CardContent>
    //       <Typography variant="h6" component="div" gutterBottom>
    //         {title}
    //       </Typography>
    //       <Typography variant="subtitle1" color="text.secondary" gutterBottom>
    //         {author}
    //       </Typography>
    //       <ReactMarkdown>
    //         {summary}
    //       </ReactMarkdown>
    //       <Typography variant="body2" color="text.secondary">
    //         Subject: {metadata.subjects}
    //       </Typography>
    //       <Typography variant="body2" color="text.secondary">
    //         Bookshelf: {metadata.bookshelves}
    //       </Typography>
    //       <Typography variant="body2" color="text.secondary">
    //         LoC Classification: {metadata.locc}
    //       </Typography>
    //       <Link href={gutenbergLink} target="_blank" rel="noopener noreferrer">
    //         <Typography variant="body2" sx={{ mt: 1 }}>
    //           View on Project Gutenberg
    //         </Typography>
    //       </Link>
    //     </CardContent>
    //   </Box>
    // </Card>
  );
};

export default BookMetadata;